/* Copyright (c) 2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { useUpdateCustomActionMutation } from "~/generated/graphql";
import { showError } from "~/services/toast";
import { useCustomAction } from "~/views/customActions/CustomActionDetails/CustomActionProvider";
import { FormData } from "../../types";
import { getUpdateObject } from "./utils";

type Props = {
  onSuccess: () => void;
};

export function useUpdateCustomAction({ onSuccess }: Props) {
  const { customAction } = useCustomAction();
  const [updateCustomActionMutation, { loading }] =
    useUpdateCustomActionMutation({
      onCompleted: (data) => {
        if (data.updateAction) {
          onSuccess();
        }
      },
      onError: (error) => {
        showError(error.message);
      },
      context: {
        headers: {
          "apollo-require-preflight": "true",
        },
      },
    });

  function updateAction(data: FormData) {
    customAction &&
      updateCustomActionMutation({
        variables: {
          input: {
            ...getUpdateObject(data, customAction),
          },
        },
      });
  }

  return [updateAction, loading] as const;
}
